import Change3DSMethodDialog from './Change3DSMethodDialog';

export default Change3DSMethodDialog;